import { createActionTypes } from "@helpers/redux-helpers";

export const reportCreatorActionTypes = createActionTypes("report/creator");

export const reportPostActionTypes = createActionTypes("report/post");
